// Cache leve de "stale-while-revalidate" para acelerar a primeira pintura de
// páginas pesadas (Kanban, Dashboard, Atendimentos, Clientes).
//
// Como funciona: ao montar a página, lemos um snapshot salvo na sessão
// (sessionStorage) e usamos como estado inicial, então a tela já aparece com
// dados em vez de girar um spinner. O fetch real de sempre continua rodando
// normalmente e, quando responde, SUBSTITUI os dados e atualiza o snapshot -
// então a tela nunca fica "presa" no dado antigo, só evita a tela em branco.
//
// sessionStorage (não localStorage) de propósito: expira sozinho quando a aba
// fecha, então nunca sobrevive a um fechar-e-abrir o navegador depois de dias.
//
// IMPORTANTE: sempre inclua companyId (e, se fizer sentido, userId) na chave.
// Sem isso, um usuário que troca de empresa/login na mesma aba veria por um
// instante os dados em cache da empresa anterior.

const PREFIX = "pageCache:v1:";

export function readPageCache(key, maxAgeMs = 2 * 60 * 1000) {
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== "number") return null;
    if (Date.now() - parsed.ts > maxAgeMs) return null;
    return parsed.data;
  } catch (e) {
    return null;
  }
}

export function writePageCache(key, data) {
  if (!key) return;
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify({ ts: Date.now(), data }));
  } catch (e) {
    // sessionStorage cheio/indisponível (modo privado etc.) - ignora silenciosamente,
    // a página continua funcionando normalmente, só sem o atalho de velocidade.
  }
}

export function clearPageCache(key) {
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch (e) {
    // ignore
  }
}
